import React from 'react';

const SvgFlecheBasGrande = (props: any) => (
<svg viewBox="0 0 73.6 263" {...props}>
<polygon points="67,217.3 41.3,244.9 41.3,0 32.3,0 32.3,244.9 6.6,217.3 0,223.4 36.8,263 73.6,223.4 "/>
</svg>
);

export default SvgFlecheBasGrande;
